import { Component, OnInit, Input, ViewEncapsulation, ElementRef, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { QuibblService } from '../../quibbl.service';
import { AuthService } from '../../auth.service';

@Component({
  selector: 'activity-list',
  templateUrl: './activity.component.html',
  styleUrls: ['./activity.component.scss']
})
export class ActivityComponent implements OnInit {

  @Input() category: string;
  @Input() user: string;
  @Input() listening: boolean;

  public loadLimit = 10;
  public activitySubscription;
  public activity;

  public isFetching = false;
  public reachedEnd = false;

  @ViewChild('activityList') private scrollContainer: ElementRef;

  constructor(public qb: QuibblService,
              private auth: AuthService) { }

  ngOnInit() {
  }

  ngOnDestroy() {
    if(this.activitySubscription) this.activitySubscription.unsubscribe();
  }

  ngOnChanges() {
    if(this.activitySubscription) this.activitySubscription.unsubscribe();
    if(!this.listening) return;

    this.reachedEnd = false;
    this.isFetching = true;

    // Scroll to top
    try {
      this.scrollContainer.nativeElement.scrollTop = 0;
    } catch(err) { }

    if(this.user) {
      this.activitySubscription =
        this.qb.getActivityForUser(this.user, this.loadLimit).subscribe(activity => {
          this.activity = [];
          for(let i=activity.length-1; i>=0; i--) {
            this.activity.push(activity[i]);
          }
          this.isFetching = false;
        });
    }

    else {
      this.activitySubscription =
        this.qb.getActivity(this.category, this.loadLimit).subscribe(activity => {
          this.activity = [];
          for(let i=activity.length-1; i>=0; i--) {
            this.activity.push(activity[i]);
          }
          this.isFetching = false;
        });
    }
  }

  onScroll(event) {
    if(event.target.scrollHeight - event.target.scrollTop - event.target.clientHeight < 100) {
      this.fetchMoreActivity();
    }
  }

  public fetchMoreActivity() {
    if(this.reachedEnd || this.isFetching) {
      return;
    }

    //console.log("FETCHING");
    this.isFetching = true;

    if(this.user) {
      if(this.activitySubscription) this.activitySubscription.unsubscribe();
      this.activitySubscription =
        this.qb.getActivityForUser(this.user, this.activity.length + this.loadLimit).subscribe(activity => {
          let diff = activity.length - this.activity.length;
          if(diff < this.loadLimit) {
            this.reachedEnd = true;
          }
          for(let i=diff-1; i>=0; i--) {
            if(activity[i]) {
              this.activity.push(activity[i]);
            }

            else {
              this.reachedEnd = true;
              break;
            }
          }

          if(this.reachedEnd) {
            //console.log("reached end");
          }

          this.isFetching = false;
        });
    }

    else {
      if(this.activitySubscription) this.activitySubscription.unsubscribe();
      this.activitySubscription =
        this.qb.getActivity(this.category, this.activity.length + this.loadLimit).subscribe(activity => {
          let diff = activity.length - this.activity.length;
          if(diff < this.loadLimit) {
            this.reachedEnd = true;
          }
          for(let i=diff-1; i>=0; i--) {
            if(activity[i]) {
              this.activity.push(activity[i]);
            }

            else {
              this.reachedEnd = true;
              break;
            }
          }

          if(this.reachedEnd) {
            //console.log("reached end");
          }

          this.isFetching = false;
        });
    }
  }

}



// WEBPACK FOOTER //
// /Users/nicholasgerard/Documents/Quibbl/quibbl/src/app/common/activity/activity.component.ts